import UIConfig from '@/UIConfig.ts';

const PremiumBadge = ({ text }: { text: string }) => {
  return (
    <span
      style={{
        background: UIConfig.Colors.GradientPremium,
        borderRadius: '4px',
        padding: '2px 6px',
        fontSize: '14px',
        marginLeft: '8px',
        color: '#FFF',
        marginTop: 4
      }}
    >
      {text}
    </span>
  );
};

export default PremiumBadge;
